import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import FounderForm from '@/components/Cms/FounderForm/FounderForm.vue';
import { getFounderById, patchFounderById } from '@/services/drUniversity/founders/founder.service';
import type { Founder } from '@/services/drUniversity/founders/founder.model';
import { FounderCardProps } from '@/components/DrUniversity/FounderCard/FounderCard.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditFounder',
  setup(__props) {

const route = useRoute();

const founder = ref<FounderCardProps | undefined>(undefined);
const loading = ref(true);
const saving = ref(false);
const success = ref(false);
const errorMessage = ref('');

onMounted(async () => {
  try {
    const id = Number(route.params.id);
    if (!id) throw new Error('Invalid founder ID');
    founder.value = await getFounderById(id);
  } catch (err: any) {
    console.error(err);
    errorMessage.value = err?.message || 'Failed to load founder.';
  } finally {
    loading.value = false;
  }
});

async function handleUpdate(payload: Founder) {
  if (!founder.value?.id) return;

  saving.value = true;
  success.value = false;
  errorMessage.value = '';

  try {
    await patchFounderById(founder.value.id, payload);
    success.value = true;
  } catch (err: any) {
    console.error(err);
    errorMessage.value = err?.message || 'Failed to update founder.';
  } finally {
    saving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-6 w-100",
        "max-width": "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Edit Founder", -1)
            ]))]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "d-flex mx-auto my-6"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(FounderForm, {
                  initialData: founder.value,
                  onSubmit: handleUpdate,
                  loading: saving.value
                }, null, 8, ["initialData", "loading"]),
                (errorMessage.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "mt-4 text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 1,
                      type: "success",
                      variant: "tonal",
                      class: "mt-4 text-center"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Founder updated successfully. ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})